// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vVWU","name":"styles_name__1tSnU","phone":"styles_phone__Z8Q4I"};